const ITEMS = [
  "WARDOGS — ALL-OUT WARFARE",
  "100 GIOCATORI // 3 SCHIERAMENTI // 1 OBIETTIVO",
  "BULKHEAD × TEAM17",
  "EARLY ACCESS 2026 SU STEAM",
  "SCEGLI IL TUO SCHIERAMENTO: LONESTAR / VALKYRA / MANTICORE",
  "DISTRUZIONE TOTALE DEL CAMPO DI BATTAGLIA",
];

export function Marquee({ className = "" }) {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y border-[#1A1A1A] bg-[#050505] py-3 ${className}`}
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-mono text-[11px] uppercase tracking-[0.3em] text-steel">
            <span className="px-8">{item}</span>
            <span className="text-wardogs">///</span>
          </span>
        ))}
      </div>
    </div>
  );
}
